import isEmpty from "ramda/es/isEmpty";
import isNil from "ramda/es/isNil";
/**
 * Validate required field
 *
 * @documented
 * @category Common
 * @import import { isRequired } from '@gef-ui/validations/validationFunctions/common'
 * @param {Object} input
 * @param {String} [input.messageKey=requiredField]
 * @returns {String} errMessage
 *
 */ const isRequired = ({ messageKey = 'requiredField' })=>({ fieldValue, descriptor })=>{
        const requiredMessage = descriptor?.requiredMessage || messageKey;
        return descriptor.required && (isNil(fieldValue) || isEmpty(fieldValue)) && (requiredMessage || messageKey);
    };
export default {
    isRequired
};
